import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    podcastListingMixin
} from './vue/mixins/podcast';
import lazyload from './features/lazy-load';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';

lazyload();
initMain([podcastListingMixin], {
    DatePicker,
    PodcastAcResults: () => import('./vue/components/podcast-ac-results/PodcastAcResults.vue'),
    PodcastPager: () => import('./vue/components/podcast-pager/PodcastPager.vue')
}, []);
header();